import React from "react";
import { Link } from "react-router-dom";
import { siteData } from "../mock";
import { Instagram, Facebook, Youtube, Twitter, Mail, ShieldCheck, Lock, CreditCard } from "lucide-react";

const iconMap = { Instagram, Facebook, Youtube, Twitter, Mail };

export default function Footer() {
  const brand = siteData.brand.name;
  const letters = brand.split("");

  return (
    <footer className="bg-[#050505] border-t border-white/5 pt-16 pb-8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex flex-col leading-none mb-4">
              <span className="font-wordmark font-normal text-4xl tracking-wide">
                {letters.map((l, i) => (
                  <span key={i} className={i === 3 ? "deal-yellow" : "text-white"}>{l}</span>
                ))}
              </span>
              <span className="font-wordmark text-white/95 text-2xl tracking-wide mt-0.5">
                {siteData.brand.tagline}
              </span>
            </div>
            <p className="text-white/60 text-sm max-w-xs leading-relaxed">
              Building stronger bodies and minds since 2013. 10521 Croatia Way, Manassas, VA 20109.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <p className="deal-yellow font-heading tracking-[0.3em] text-sm mb-5">QUICK LINKS</p>
            <ul className="space-y-3">
              {siteData.navigation.map((n) => (
                <li key={n.label}>
                  <a
                    href={n.href}
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.querySelector(n.href);
                      if (el) el.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="text-white/70 hover:text-[#e10600] text-sm tracking-[0.15em] font-heading transition-colors"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social + Contact */}
          <div>
            <p className="deal-yellow font-heading tracking-[0.3em] text-sm mb-5">CONNECT</p>
            <div className="flex gap-3 mb-6">
              {siteData.contact.socials.map((s) => {
                const Icon = iconMap[s.icon];
                return (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    className="w-10 h-10 rounded-md border border-white/15 flex items-center justify-center text-white/80 hover:text-[#0a0a0a] hover:bg-[#e10600] hover:border-[#e10600] transition-colors"
                  >
                    {Icon && <Icon size={18} />}
                  </a>
                );
              })}
              <a
                href={`mailto:${siteData.contact.email}`}
                aria-label="Email"
                className="w-10 h-10 rounded-md border border-white/15 flex items-center justify-center text-white/80 hover:text-[#0a0a0a] hover:bg-[#e10600] hover:border-[#e10600] transition-colors"
              >
                <Mail size={18} />
              </a>
            </div>
            <a
              href={`mailto:${siteData.contact.email}`}
              className="block text-white/80 hover:deal-yellow text-sm mb-1"
            >
              {siteData.contact.email}
            </a>
            <p className="text-white/60 text-sm">10521 Croatia Way, Manassas, VA 20109</p>
          </div>
        </div>

        {/* Trust badges row */}
        <div className="flex flex-wrap items-center justify-center gap-3 mb-6 pt-2">
          <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-white/10 bg-white/5">
            <ShieldCheck size={14} className="text-emerald-400" strokeWidth={2.4} />
            <span className="text-white/85 text-[10px] tracking-[0.2em] font-heading font-semibold">
              SSL SECURED
            </span>
          </div>
          <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-white/10 bg-white/5">
            <Lock size={14} className="text-emerald-400" strokeWidth={2.4} />
            <span className="text-white/85 text-[10px] tracking-[0.2em] font-heading font-semibold">
              PRIVACY PROTECTED
            </span>
          </div>
          <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-white/10 bg-white/5">
            <CreditCard size={14} className="text-emerald-400" strokeWidth={2.4} />
            <span className="text-white/85 text-[10px] tracking-[0.2em] font-heading font-semibold">
              SECURE PAYMENTS · SQUARE
            </span>
          </div>
        </div>

        <div className="glow-divider mb-6" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/50 text-xs tracking-[0.15em]">
            © {new Date().getFullYear()} THEDEAL FITNESS · {siteData.brand.location}
          </p>
          <div className="flex items-center gap-5">
            <Link
              to="/privacy"
              className="text-white/60 hover:text-[#e10600] text-xs tracking-[0.15em] font-heading transition-colors"
            >
              PRIVACY POLICY
            </Link>
            <a
              href={`mailto:${siteData.contact.email}?subject=Terms%20Question`}
              className="text-white/60 hover:text-[#e10600] text-xs tracking-[0.15em] font-heading transition-colors"
            >
              CONTACT
            </a>
            <p className="text-white/40 text-xs tracking-[0.15em] hidden md:block">
              LIVE STRONGER. LIVE THE DEAL.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
